import { useState } from 'react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
interface Props {
  isIos: boolean
  isAndroid: boolean
  closeModal : ()=>void
}

const ModalReinitialiserPasswordMobile: React.FC<Props> = ({ isIos, isAndroid, closeModal }) => {
 
  const navigate = useNavigate()

  return (

      <div className='justify-center flex items-center fixed inset-0 z-50 bg-[#4945c12f] backdrop-blur-sm '>
          <div className='rounded-xl h-[250px] flex flex-col justify-center shadow-xl relative gap-6 mx-1 bg-white px-2' >
              <h1 className='text-[#1D3A70] text-[20px] font-semibold text-center'>Souhaitez-vous ouvrir l&apos;application ou rester sur le navigateur ?</h1>
              <div className='flex items-center justify-center gap-5 w-full'>
              <button
                
                onClick={() => { closeModal 

                   navigate('/login')}}
                className='rounded-xl h-[50px] w-[130px] text-white text-[15px] font-medium bg-green-500'
              >
                Rester sur le navigateur
              </button>
              <button
                 onClick={() => {
                   closeModal
                 
                            if (isAndroid) {
                              window.open('https://play.google.com/store/apps/details?id=com.myeasytransfert&hl=en_US', '_blank')
                            } else if (isIos) {
                              window.open('https://apps.apple.com/ci/app/my-easy-transfer/id1572782943', '_blank')
                            }
                          }}
                    className='rounded-xl h-[50px] w-[130px] text-white text-[15px] font-medium bg-green-500'
                  >
                Ouvrir l&apos;application
              </button>
              </div>
            </div>
          </div>
      
  )
}

export default ModalReinitialiserPasswordMobile
